import React from 'react';
import I18n from 'i18n-js';
import { inIframe } from 'modules/TCIUtils';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import Icon from '@/components/ui/Icon';
import EndSessionButton from '@/components/admin/SlideShow/PresentMode/Navigator/Controls/Settings/EndSessionButton';
import PresentingCount from '@/components/admin/SlideShow/PresentMode/Navigator/Controls/PresentingCount';
import BackToButton, { BackToButtonProps as BackButtonPropType } from './Controls/BackToButton';
import useSessionNavigationLock from '../useSessionNavigationLock';

interface LeftGridContentProps {
  activeSessionId?: string | number;
  BackToButtonProps: BackButtonPropType;
  isNavigationLocked: boolean;
}

interface LeftControlProps {
  BackToButtonProps: BackButtonPropType;
}

const LeftGridContent = ({ activeSessionId, isNavigationLocked, BackToButtonProps }: LeftGridContentProps) => {
  // General button for when not in live session.
  if (!inIframe() && !activeSessionId) {
    return <BackToButton {...BackToButtonProps} />;
  }

  // For students in an active session.
  if (isNavigationLocked) {
    return (
      <div
        className="tw-flex tw-items-center tw-gap-4 tw-overflow-hidden tw-whitespace-nowrap tw-text-lg tw-text-white"
      >
        <div className="tw-h-10 tw-flex tw-items-center tw-shrink-0">
          <Icon icon="Live" size={20} />
        </div>
        <span className="tw-truncate">{I18n.t('student_following_teacher')}</span>
      </div>
    );
  }

  // For non students in live session.
  if (activeSessionId) {
    return <PresentingCount />;
  }

  return <div />;
};

const LeftControl = ({ BackToButtonProps }: LeftControlProps) => {
  const activeSessionId = useSlideShowContext(state => state.activeSessionId);
  const { isNavigationLocked } = useSessionNavigationLock();

  return (
    <>
      <LeftGridContent
        activeSessionId={activeSessionId}
        BackToButtonProps={BackToButtonProps}
        isNavigationLocked={isNavigationLocked}
      />
      {activeSessionId && <EndSessionButton />}
    </>
  );
};

export default LeftControl;
